module.exports = __webpack_public_path__ + "img/header-background-leader-board.6cf3f171.png";